/**
 * Точка входа React-приложения виджета «Оплаты».
 * Монтирует App внутрь QueryClientProvider (@tanstack/react-query v5).
 *
 * Приложение работает в IFRAME внутри карточки сделки amoCRM: контекст и авторизация
 * поднимаются в useAuth (см. App). StrictMode оставлен — эффекты идемпотентны
 * (handshake защищён однократностью, запросы отменяемы).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { App } from './App';
import 'react-day-picker/style.css';
import './theme.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
